import React, { useMemo } from "react";

export enum ReconStatus {
  unmatched = 'unmatched',
  notFound = 'notFound',
  noIssues = 'noIssues'
}
export default function ReconStatusChip({ count, status }: { count: number; status: ReconStatus }) {
  const statusLabel = useMemo(() => {
    switch (status) {
      case ReconStatus.noIssues: return "No Issues";
      case ReconStatus.notFound: return "Not Found";
      case ReconStatus.unmatched: return "Unmatched";
    }
  }, [status])
  const statusColor = useMemo(() => {
    switch (status) {
      case ReconStatus.noIssues: return { text: "#10A957", bg: "#EFFEF5" };
      case ReconStatus.notFound: return { text: "#FE9239", bg: "#FFFAFA" };
      case ReconStatus.unmatched: return { text: "#FF5E5E", bg: "#FFFAFA" };
    }
  }, [status])
  return <div className={`flex px-8 py-[1px] items-center gap-2 text-12 font-regular border rounded-[12px] whitespace-nowrap`} style={{ borderColor: statusColor.text, backgroundColor: statusColor.bg, color: statusColor.text }}>
    <span
      className="rounded-[100%] w-6 h-6 inline-block mr-[4px]"
      style={{ backgroundColor: statusColor.text }}
    ></span>
    <div>{count}</div>
    <div>{statusLabel}</div>
  </div>
}